import React from 'react';
import Hero from './Hero';
import ActionButtons from './ActionButtons';
import JobListings from './JobListing';
import Footer from '../About/Footer';
import Navbar from '../About/Navbar';
import Home from './Homev2';

export default function HomePage() {
  return (
    <div className="page-container">
      <Navbar />
      <Hero />
      <Home />
      <Footer />
    </div>
  );
}